import { TagPicker } from '@fluentui/react';
import { Label } from 'office-ui-fabric-react';
import React, { Component, Fragment } from 'react';
import { DataCompte } from '../../data/DataCompte';
import { Immocom } from '../../specifique/immocom';

export class PickerEmail extends Component {

    static defaultProps = {
        autoComplete: "off",
        disabled: false,
        label: "Emails",
        onChange: (emails) => null,
        required: false,
        emails: [],
    };

    constructor(props) {
        super(props);
        this.emails = [];
        this.state = { emailsEnCoursDAjout: "" };
    };

    _chargementDonnees = () => {
        DataCompte._chargementComptes({}, "Email", false)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const comptes = responseFetch.reponseAPIobjet || [];
                    const emails = [...new Set(
                        comptes
                            .filter(compte => !!compte.email)
                            .map(compte => compte.email.toLowerCase().trim())
                    )];
                    this.emails = emails.sort();
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
    };

    _onBlur = () => {
        const emailsAAjouter = this.state.emailsEnCoursDAjout
            .toLowerCase()
            .split(";")
            .map(email => email.trim())
            .filter(Boolean); // Suppression des valeurs nulles

        if (emailsAAjouter.length > 0) {
            let emailsCorrects = [...this.props.emails];
            let emailsIncorrects = [];
            emailsAAjouter.forEach((email, index) => {
                if (/^\S+@\S+\.\S+$/.test(email)) emailsCorrects.push(email);
                else emailsIncorrects.push(email);
            });
            this.setState(
                { emailsEnCoursDAjout: emailsIncorrects.join(";") },
                () => this.props.onChange(Array.from(new Set(emailsCorrects)))
            )
        }
    };

    _onChange = (items) => {
        this.props.onChange(items.map(item => item.key))
    };

    _onInputChange = (input) => {
        this.setState({ emailsEnCoursDAjout: input.trim() });
        return input.trim();
    };

    _onResolveSuggestions = (filter, selectedItems) => {
        if (!!filter && filter.length >= 3)
            return this.emails
                .filter(email => email.includes(filter))
                .map(email => ({ key: email, name: email }));
        else return [];
    };

    componentDidMount = () => {
        if (this.props.autoComplete === "on")
            this._chargementDonnees();
    };

    render = () => {
        const { disabled, emails, label, required } = this.props;
        const { emailsEnCoursDAjout } = this.state;
        const styles = disabled ? { input: { display: "none" } } : {};

        return <Fragment>
            <Label required={required} disabled={disabled}>{label}</Label>
            <TagPicker
                disabled={disabled}
                inputProps={{ value: emailsEnCoursDAjout || " " }} // Espace ; bypass un bug de FluentUI qui ne rerender pas correctement l'input s'il est vide
                onBlur={this._onBlur}
                onChange={this._onChange}
                onInputChange={this._onInputChange}
                onResolveSuggestions={this._onResolveSuggestions}
                resolveDelay={1}
                selectedItems={emails.filter(email => !!email).map(email => ({ key: email, name: email }))}
                styles={styles}
            />
        </Fragment>;
    };

}